import firebase from '@firebase/app'
import '@firebase/auth'
import '@firebase/firestore'


// Kinetic Payment Plus
const config = {
    apiKey: 'AIzaSyCldR71gWjFETVUW-74A0d7ifV2UjO0Zhs',
    authDomain: 'kinetic-payment-plus.firebaseapp.com',
    databaseURL: 'https://kinetic-payment-plus.firebaseio.com',
    projectId: 'kinetic-payment-plus',
    storageBucket: 'kinetic-payment-plus.appspot.com',
    messagingSenderId: '1026503536202'
}

/*
// Kinetic Goodbox
const config = {
  apiKey: "AIzaSyBF4yJRfmlUhaRa4mrdPMBeZBIF1YZ_LV8",
  authDomain: "kinetic-goodbox.firebaseapp.com",
  databaseURL: "https://kinetic-goodbox.firebaseio.com",
  projectId: "kinetic-goodbox",
  storageBucket: "kinetic-goodbox.appspot.com",
  messagingSenderId: "243989693717"
};
*/
firebase.initializeApp(config)

const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser

const groupsCollection = db.collection('groups')
const macStartKeysCollection = db.collection('mac_start_keys')
const settingsCollection = db.collection('settings')
const statusesCollection = db.collection('statuses')
const tokensCollection = db.collection('tokens')
const transactionsCollection = db.collection('transactions')
const usersCollection = db.collection('users')
const formsCollection = db.collection('forms')
const devicesCollection = db.collection('devices')
const templatesCollection = db.collection('templates')
const logCollection = db.collection('activity')

export {
    db,
    auth,
    currentUser,
    groupsCollection,
    macStartKeysCollection,
    settingsCollection,
    statusesCollection,
    tokensCollection,
    transactionsCollection,
    usersCollection,
    formsCollection,
    devicesCollection,
    templatesCollection,
    logCollection
}
